var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTablerDock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6162 25.6316H6.03103C4.8314 25.6316 3.6809 25.155 2.83263 24.3068C1.98436 23.4585 1.50781 22.308 1.50781 21.1084C1.50781 19.9087 1.98436 18.7582 2.83263 17.91C3.6809 17.0617 4.8314 16.5851 6.03103 16.5851H22.6162C21.4165 16.5851 20.266 17.0617 19.4178 17.91C18.5695 18.7582 18.0929 19.9087 18.0929 21.1084C18.0929 22.308 18.5695 23.4585 19.4178 24.3068C20.266 25.155 21.4165 25.6316 22.6162 25.6316ZM22.6162 25.6316H24.1239C25.3235 25.6316 26.474 25.155 27.3223 24.3068C28.1706 23.4585 28.6471 22.308 28.6471 21.1084V4.52323C28.6471 3.72347 28.3294 2.95648 27.7639 2.39096C27.1984 1.82545 26.4314 1.50775 25.6316 1.50775H10.5542C9.75449 1.50775 8.98749 1.82545 8.42198 2.39096C7.85647 2.95648 7.53877 3.72347 7.53877 4.52323V16.5851",
    stroke: "currentColor",
    strokeWidth: 3.01548,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablerDock);
export default __webpack_public_path__ + "static/media/tabler-dock.37727595de5b0b237a9f5d89ecb28ff3.svg";
export { ForwardRef as ReactComponent };